/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue');

// Vue.config.productionTip = false
// Vue.config.devtools = false;
// Vue.config.debug = false;
// Vue.config.silent = true; 

import '@mdi/font/css/materialdesignicons.css';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import router from './router';
import store from "./store/index";
import vueDebounce from 'vue-debounce';

Vue.use(Vuetify)

const opts = {
    icons: {
        iconfont: 'mdi'
    },
    theme: {
        themes: {
            light: {
                tampan: "#F44336"
            },
        },
    },
}

Vue.use(vueDebounce, {
    lock: true
})

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i);
// console.log(files.keys());
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

// Vue.component('example-component', require('./components/ExampleComponent.vue').default);
Vue.component('my-app', require('./App.vue').default);
Vue.component('loading-assets', require('./components/main/LoadingAssets.vue').default);

// Vue.filter('role', function(r){
//     if(r == "1"){
//         return "Operator Sekolah"
//     } else if(r == 2) {
//         return "Guru"
//     } else {
//         return "Admin Disdik"
//     }
// });

// Vue.filter('ucwords', function(str){
//     return str.toLowerCase()
//     .split(' ')
//     .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
//     .join(' ');
// });


/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

var filter = function(text, length, clamp) {
    clamp = clamp || '...';
    var node = document.createElement('div');
    node.innerHTML = text;
    var content = node.textContent;
    return content.length > length ? content.slice(0, length) + clamp : content;
};

Vue.filter('truncate', filter);

const app = new Vue({
    el: '#app',
    store,
    router,
    vuetify: new Vuetify(opts),
    data: { loading: false },
});

router.beforeEach((to, from, next) => {
    app.loading = true
    next()
})

router.afterEach(() => {
    setTimeout(() => app.loading = false, 0) // timeout for demo purposes
})